<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top" @click="onAdd()">
        <div class="flex-1 font-16-30313a">模板分类</div>
        <div class="tip-20-bg-30313a">
          <i class="el-icon-plus font-bold"></i>
        </div>
      </div>
      <div class="flex-1 h-0" v-if="classifyList && classifyList.length > 0">
        <cate-menu :menu-data="classifyList" :not-add="true" @on-edit="onEdit" @on-delete="onDelete" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0">
      <div class="flex content-top mt-10">
        <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
          <div class="tab-item active">
            <span class="bg-4-f5971d"></span>
            {{currentClassify.name}}
          </div>
        </div>
      </div>
      <div style="padding: 10px 20px 20px 0" class="flex-column h-100">
        <div class="flex mb-10">
          <div class="btn-24-bg-ff flex align-center mr-5" @click="onAddDetail">
            <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
            新增
          </div>
          <div class="btn-24-bg-ff flex align-center mr-5" @click="onDeleteDetail">
            <img src="/static/images/shanchu.png" class="icon-14 mr-5" alt="">
            删除
          </div>
        </div>
        <div class="flex-1 mb-10">
          <erp-table :is-edit="true" ref="erpTable" :table-data="tableData" :loading="loading"  @on-modify="onModifyInRow" modify-method="on-modify"
                     :column-data="tableColumn" @on-is-accounting="onIsAccounting" @on-is-modified="onIsModified"></erp-table>
        </div>
      </div>
    </div>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="300px" title="模板分类" :visible.sync="isClassifyShow" @closed="onCloseClassify">
      <div class="p-20">
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">模板分类名称：</div>
          <el-input v-model="newClassify.name" class="flex-1" placeholder="请输入分类名称"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseClassify">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="submitClassify">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CateMenu from '@/components/CateMenu'
import MoveHorizon from '@/components/MoveHorizon'
import ErpTable from '@/components/ErpTable'
export default {
  name: 'BillDefine',
  components: {CateMenu, MoveHorizon, ErpTable},
  props: ['type', 'options'],
  data () {
    return {
      classifyList: [],
      newClassify: {},
      isClassifyShow: false,
      chooseMenuId: 0,
      currentClassify: {},
      tableData: [],
      tableColumn: [
        {
          type: 'selection',
          width: '40',
          fixed: 'left'
        }, {
          field: 'sort',
          title: '序号',
          width: '50',
          fixed: 'left',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'type',
          title: '类型',
          width: '120',
          editType: 'select',
          editRender: {
            name: 'select',
            options: this.options
          },
          formatter: 'toBillType'
        }, {
          field: 'isAccounting',
          title: '记账',
          width: '60',
          isDefine: true,
          child: [{
            title: '是',
            key: 'isAccounting',
            methodName: 'on-is-accounting',
            type: 'radio',
            activeValue: 1,
            inactiveValue: 0
          }]
        }, {
          field: 'isModified',
          title: '修改',
          width: '60',
          isDefine: true,
          child: [{
            title: '是',
            key: 'isModified',
            methodName: 'on-is-modified',
            type: 'radio',
            activeValue: 1,
            inactiveValue: 0
          }]
        }, {
          field: 'specialItem',
          title: '特项',
          width: '80',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'statisticalName',
          title: '统计名称',
          width: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'fundContent',
          title: '款项内容',
          minWidth: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'formulaCompute',
          title: '公式',
          minWidth: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'description',
          title: '说明',
          minWidth: '150',
          editRender: {
            name: 'input'
          }
        }
      ],
      loading: false
    }
  },
  created () {
    this.getClassify(true)
  },
  mounted () {},
  methods: {
    onDeleteDetail () {
      let dataArr = this.$refs.erpTable.getSelectEvent()
      if (!dataArr.length) {
        this.$message({
          message: `请先选择要删除的数据`,
          type: 'warning'
        })
      } else {
        let idArr = []
        let that = this
        for (let i = 0; i < dataArr.length; i++) {
          idArr.push(dataArr[i].id)
        }
        this.$confirm(`是否将选中数据彻底删除？删除后不可恢复！`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ids: idArr.join(',')
          }
          that.axios.post('billItemTemplate/deleteByIds', this.qs.stringify(params)).then(res => {
            if (res.data.success) {
              that.$message({
                message: '删除成功',
                type: 'success'
              })
              that.getDetail()
              that.$refs.erpTable.setAllSelection(false)
            } else {
              that.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      }
    },
    onAddDetail () {
      let params = {
        billId: this.currentClassify.id
      }
      this.axios.post('billItemTemplate/save', params).then(res => {
        if (res.data.success) {
          this.$refs.erpTable.insertAt(res.data.data, this.tableData[0], 'specialItem')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onIsModified (row) {
      this.onModifyInRow(row, null, 'isModified')
    },
    onIsAccounting (row) {
      this.onModifyInRow(row, null, 'isAccounting')
    },
    onModifyInRow (row, column, colName) {
      let params = {
        id: row.id,
        [colName]: row[colName]
      }
      this.axios.post('/billItemTemplate/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.getDetail()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getDetail () {
      this.loading = true
      this.axios.post('billItemTemplate/list', {billId: this.currentClassify.id}).then(res => {
        this.loading = false
        if (res.data.success) {
          this.tableData = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    submitClassify () {
      if (!this.newClassify.name) {
        this.$message.warning('请输入分类名称')
      } else {
        let url = 'billTemplate/save'
        let type = '新增'
        if (this.newClassify.id) {
          url = 'billTemplate/modify'
          type = '修改'
        } else {
          this.newClassify.companyId = this.$store.state.companyId
          this.newClassify.type = this.type
        }
        this.axios.post(url, this.newClassify).then(res => {
          if (res.data.success) {
            this.$message.success(type + '模板分类成功')
            this.getClassify()
            this.isClassifyShow = false
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    onCloseClassify () {
      this.isClassifyShow = false
      this.newClassify = {}
    },
    getClassify (isRefresh) {
      this.classifyList = []
      this.axios.post('billTemplate/list', {type: this.type, companyId: this.$store.state.companyId}).then(res => {
        if (res.data.success) {
          this.classifyList = res.data.data
          if (isRefresh) {
            if (this.classifyList.length > 0) {
              this.currentClassify = this.classifyList[0]
              this.chooseMenuId = this.classifyList[0].id
              this.getDetail()
            }
          }
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg,
            offset: 400
          })
        }
      })
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseMenuId) {
        this.currentClassify = menu
        this.chooseMenuId = menu.id
        this.getDetail()
      }
    },
    onDelete (menu) {
      let that = this
      this.$confirm('此操作将永久删除该模板分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('billTemplate/deleteById', this.qs.stringify({id: menu.id})).then(res => {
          if (res.data.success) {
            that.getClassify(that.chooseMenuId === menu.id)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg,
              offset: 400
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onEdit (menu) {
      this.newClassify = {
        id: menu.id,
        name: menu.name
      }
      this.isClassifyShow = true
    },
    onAdd () {
      this.isClassifyShow = true
      this.newClassify = {}
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .dialog-left-top {
    height: 40px;
    border-bottom: 1px solid #e2e2e2;
    line-height: 40px;
    padding: 0 20px;
    font-size: 16px;
    color: #30313a;
    text-align: left;
    background-color: #ffffff;
  }
  .content-top {
         height: 30px;
         .tab-item {
           font-size: 16px;
           color: #272727;
           display: flex;
           align-items: center;
           margin-right: 15px;
           cursor: pointer;
           span {
             height: 16px;
           }
           &.active {
             color: #f5971d;
           }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/component/BillDefine.vue